// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageSwitcher_wrapper__w2UvR","inactive":"LanguageSwitcher_inactive__PY7Za"};